export default {
    "BLOCK_WIDTH_DROPDOWN": [
        {
            title: "Default",
            id: -1
        },
        {
            title: "40%",
            id: 40
        },
        {
            title: "60%",
            id: 60
        },
        {
            title: "100%",
            id: 100
        }
    ],
    "OPACITY_DROPDOWN": [
        {
            title: "0%",
            id: 0
        },
        {
            title: "20%",
            id: 0.2
        },
        {
            title: "40%",
            id: 0.4
        },
        {
            title: "60%",
            id: 0.6
        },
        {
            title: "80%",
            id: 0.8
        },
        {
            title: "100%",
            id: 1
        }
    ],
    "PAGE_ITEMS_ORDER_DROPDOWN": [
        {
            title: "Newest",
            id: 'desc'
        },
        {
            title: "Oldest",
            id: 'asc'
        },
    ],
    "FEATURES": {
        "MENU": {
            "ID": 1,
            "NAME": "Menu"
        },
        "WIDGETS": {
            "ID": 2,
            "NAME": "Widgets"
        },
        "GLOBAL_FIELDS": {
            "ID": 3,
            "NAME": "Global fields"
        }
    },
    "VISIBILITY_OPTION_DROPDOWN": [
        {
            title: "Everyone is allowed",
            id: 1,
            disclaimer: {
                text: "Everyone has access to view the page",
                icon: "users"
            }
        },
        {
            title: "Only people which are allowed",
            id: 2,
            disclaimer: {
                text: "Restricted access",
                icon: "user-times"
            },
            addUsers: true
        }
    ],
    "FORM_FIELD_TYPE_DROPDOWN": [
        {
            title: "Number",
            id: "number"
        },
        {
            title: "Text",
            id: "text"
        },
        {
            title: "Submit",
            id: "submit"
        }
    ],
    "FORM_FIELD_VALIDATE_DROPDOWN": [
        {
            title: "Number",
            id: "number"
        },
        {
            title: "Required",
            id: "required"
        }
    ],
    "CONTENT_PUBLISH_DROPDOWN": [
        {
            title: "Published",
            id: "true"
        },
        {
            title: "Unpublished",
            id: "false"
        }
    ],
    "ARTICLE_DISPLAY_COUNT_DROPDOWN": [
        {
            title: "5",
            id: 5
        },
        {
            title: "10",
            id: 10
        },
        {
            title: "15",
            id: 15
        },
    ]
}



// WEBPACK FOOTER //
// ./src/core/admin/config/constants.js